// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-dialog[data-v-56e2f16c]{margin-top:4.25rem!important}@media(min-width:576px){.modal-dialog[data-v-56e2f16c]{max-width:51.75rem}}@media(min-width:768px){.dismiss[data-v-56e2f16c]{position:absolute;right:-4.5rem}}", ""]);
// Exports
module.exports = exports;
